import React, { useEffect, useState, Fragment } from "react";
import {
  Button,
  Stepper,
  Step,
  StepLabel,
  Grid,
  TextField,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import axios from "helpers/API";
import SelectFieldMaterialUI from "form/SelectFieldMaterialUI";
import { errorBackendMsg } from "helpers/helpers";
import { makeStyles } from "@material-ui/core/styles";
import { DatePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import APIMensajeMUI from "componentes/APIMensajeMUI";
import * as Yup from "yup";
import Autocomplete from "@material-ui/lab/Autocomplete";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import Alert from "@material-ui/lab/Alert";
const useStyles = makeStyles((theme) => ({
  cardCrear: {
    height: 120,
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    "&:hover": {
      backgroundColor: theme.palette.secondary.dark,
      cursor: "pointer",
    },
  },
  input100: {
    width: "100%",
  },
}));

function Step4({ formik, setValidationSchema, turnoInterno }) {
  const classes = useStyles();
  // API Mensaje
  const [mensajeError, setMensajeError] = useState("");
  const [showError, setShowError] = useState(false);
  const [mensajeInfo, setMensajeInfo] = useState("");
  const [showInfo, setShowInfo] = useState(false);
  const [tipoPadronOpt, setTipoPadronOpt] = useState([]);
  const [conSuscriptorOpt, setConSuscriptorOpt] = useState([]);

  const validationSchema = Yup.object({
    nroDoc: Yup.number()
      .required("Campo requerido")
      .min(1000000, "DNI Incorrecto")
      .max(99999999, "DNI Incorrecto"),
    tipoPadron: Yup.string().required("Campo requerido"),
    padron: Yup.string().required("Campo requerido").max(10, "Padrón inválido"),
    conSuscriptorId: Yup.string().required("Campo requerido"),
    nombres: Yup.string().required("Campo Requerido"),
    apellidos: Yup.string().required("Campo Requerido"),
    email: turnoInterno
      ? Yup.string().email("Email inválido")
      : Yup.string().required("Campo Requerido").email("Email inválido"),
    primEmail: Yup.string().when("email", {
      is: (val) => val && val.length > 0,
      then: Yup.string()
        .oneOf([Yup.ref("email")], "Los Emails no coinciden")
        .required("Campo Requerido"),
    }),
    telFijo: Yup.number()
      .required("Campo requerido")
      .typeError("Ingrese números en este campo")
      .min(10000000, "Numero inválido")
      .max(10000000000, "Numero inválido"),
    telMovil: Yup.number()
      .min(10000000, "Numero inválido")
      .max(10000000000, "Numero inválido"),
  });

  useEffect(() => {
    formik.touched.nroDoc = false;
    formik.touched.tipoPadron = false;
    formik.touched.padron = false;
    formik.touched.apellidos = false;
    formik.touched.padronMultiple = false;
    formik.touched.conSuscriptorId = false;
    formik.touched.nombres = false;
    formik.touched.email = false;
    formik.touched.primEmail = false;
    formik.touched.telFijo = false;
    formik.touched.telMovil = false;
    setValidationSchema(validationSchema);
    getTipos();
    getCondicionSuscriptor()
  }, []);

  const getTipos = () => {
    axios
      .post("/generales/tipoPadron/listarPorEtiqueta", {})
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setTipoPadronOpt(response.data);
          formik.setFieldValue("condSuscriptorOpt", response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  const getCondicionSuscriptor = () => {
    axios
      .post("/generales/conSuscriptor/listarPorEtiqueta", {})
      .then(function (response) {
        if (response.data.error) {
          setShowError(true);
          setMensajeError(response.data.msg);
        } else {
          setConSuscriptorOpt(response.data);
          formik.setFieldValue("tiposPadron", response.data);
        }
      })
      .catch(function (error) {
        setMensajeError(errorBackendMsg(error));
      });
  };

  return (
    <>
      <APIMensajeMUI
        mb={30}
        tipo="error"
        showMensaje={showError}
        setShowMensaje={setShowError}
        msg={mensajeError}
      />
      <APIMensajeMUI
        mb={30}
        tipo="info"
        showMensaje={showInfo}
        setShowMensaje={setShowInfo}
        msg={mensajeInfo}
      />
      <Grid container spacing={2}>
        <Grid item md={2} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label="DNI*"
            type="text"
            id="nroDoc"
            name="nroDoc"
            value={formik.values.nroDoc}
            onChange={(e) => {
              if (/^[0-9]*$/.test(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            error={formik.errors.nroDoc && formik.touched.nroDoc}
            helperText={
              formik.errors.nroDoc && formik.touched.nroDoc
                ? formik.errors.nroDoc
                : null
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <FormControl className={classes.input100} variant="outlined">
            <InputLabel>Tipo Padrón*</InputLabel>
            <Select
              variant="outlined"
              id="tipoPadron"
              label="Tipo Padrón*"
              name="tipoPadron"
              value={formik.values.tipoPadron}
              onChange={formik.handleChange}
              error={formik.errors.tipoPadron && formik.touched.tipoPadron}
              helperText={
                formik.errors.tipoPadron && formik.touched.tipoPadron
                  ? formik.errors.tipoPadron
                  : null
              }
            >
              {tipoPadronOpt.map((tipoPadron) => (
                <MenuItem value={tipoPadron.value}>{tipoPadron.label}</MenuItem>
              ))}
            </Select>
            <FormHelperText error>
              {formik.touched.tipoPadron && formik.errors.tipoPadron}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid item md={4} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label="Padrón*"
            type="text"
            id="padron"
            name="padron"
            value={formik.values.padron}
            onChange={(e) => {
              formik.handleChange(e);
            }}
            error={formik.errors.padron && formik.touched.padron}
            helperText={
              formik.errors.padron && formik.touched.padron
                ? formik.errors.padron
                : null
            }
          />
        </Grid>

        <Grid item md={6} xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={formik.values.padronMultiple}
                onChange={(e) => {
                  formik.setFieldValue(
                    "padronMultiple",
                    !formik.values.padronMultiple
                  );
                }}
                name="checkedA"
              />
            }
            label="Requiere suscripción a planes de pago para más de un padrón"
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <FormControl className={classes.input100} variant="outlined">
            <InputLabel>Condición del suscriptor</InputLabel>
            <Select
              variant="outlined"
              id="conSuscriptorId"
              label="Condición del suscriptor*"
              name="conSuscriptorId"
              value={formik.values.conSuscriptorId}
              onChange={formik.handleChange}
              error={
                formik.errors.conSuscriptorId && formik.touched.conSuscriptorId
              }
              helperText={
                formik.errors.conSuscriptorId && formik.touched.conSuscriptorId
                  ? formik.errors.conSuscriptorId
                  : null
              }
            >
              {conSuscriptorOpt.map((conSuscriptor) => (
                <MenuItem value={conSuscriptor.value}>
                  {conSuscriptor.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText error>
              {formik.touched.conSuscriptorId && formik.errors.conSuscriptorId}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label="Apellidos*"
            type="text"
            id="apellidos"
            name="apellidos"
            value={formik.values.apellidos}
            onChange={(e) => {
              if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            error={Boolean(formik.errors.apellidos) && formik.touched.apellidos}
            helperText={
              formik.errors.apellidos && formik.touched.apellidos
                ? formik.errors.apellidos
                : null
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label="Nombres*"
            type="text"
            id="nombres"
            name="nombres"
            value={formik.values.nombres}
            onChange={(e) => {
              if (/^[a-zA-Z\s]*$/.test(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            error={Boolean(formik.errors.nombres) && formik.touched.nombres}
            helperText={
              formik.errors.nombres && formik.touched.nombres
                ? formik.errors.nombres
                : null
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label={!turnoInterno ? "Email*" : "Email"}
            type="text"
            id="email"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={Boolean(formik.errors.email) && formik.touched.email}
            helperText={
              formik.errors.email && formik.touched.email
                ? formik.errors.email
                : null
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label={!turnoInterno ? "Confirmar Email*" : "Confirmar Email"}
            type="text"
            id="primEmail"
            name="primEmail"
            onPaste={(e) => {
              e.preventDefault();
              return false;
            }}
            value={formik.values.primEmail}
            onChange={(e) => {
              formik.handleChange(e);
            }}
            error={Boolean(formik.errors.primEmail) && formik.touched.primEmail}
            helperText={
              formik.errors.primEmail && formik.touched.primEmail
                ? formik.errors.primEmail
                : null
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label="Tel. Contacto 1*"
            type="text"
            id="telFijo"
            name="telFijo"
            value={formik.values.telFijo}
            onChange={(e) => {
              if (/^[0-9]*$/.test(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            error={Boolean(formik.errors.telFijo) && formik.touched.telFijo}
            helperText={
              formik.errors.telFijo && formik.touched.telFijo
                ? formik.errors.telFijo
                : null
            }
          />
        </Grid>
        <Grid item md={6} xs={12}>
          <TextField
            variant="outlined"
            className={classes.input100}
            label="Tel. Contacto 2"
            type="text"
            id="telMovil"
            name="telMovil"
            value={formik.values.telMovil}
            onChange={(e) => {
              if (/^[0-9]*$/.test(e.target.value)) {
                formik.handleChange(e);
              }
            }}
            error={Boolean(formik.errors.telMovil) && formik.touched.telMovil}
            helperText={
              formik.errors.telMovil && formik.touched.telMovil
                ? formik.errors.telMovil
                : null
            }
          />
        </Grid>
        {/* <Grid item md={4}>
                    <SelectFieldMaterialUI
                        classNameFormControl={
                            classes.input100
                        }
                        nombreLabel="Especie"
                        name="especieId"
                        hijosDirectos={["razaId", "pesoId", "edadId"]}
                        formik={formik}
                        itemsArray={especies}
                        ejecutarAccion={(id) => {
                            getCamposDependientes(id)
                        }}
                    />
                </Grid>
                <Grid item md={4}>
                    <SelectFieldMaterialUI
                        classNameFormControl={
                            classes.input100
                        }
                        nombreLabel="Sexo"
                        name="sexoId"
                        formik={formik}
                        itemsArray={sexos}
                    />
                </Grid>
                <Grid item md={4}>
                    <SelectFieldMaterialUI
                        classNameFormControl={
                            classes.input100
                        }
                        nombreLabel="Peso"
                        name="pesoId"
                        formik={formik}
                        itemsArray={pesos}
                    />
                </Grid>
                <Grid item md={4}>
                    <SelectFieldMaterialUI
                        classNameFormControl={
                            classes.input100
                        }
                        nombreLabel="Edad"
                        name="edadId"
                        formik={formik}
                        itemsArray={edades}
                    />
                </Grid>
                <Grid item md={4}>
                    <SelectFieldMaterialUI
                        classNameFormControl={
                            classes.input100
                        }
                        nombreLabel="Raza"
                        name="razaId"
                        formik={formik}
                        itemsArray={razas}
                    />
                </Grid>
                <Grid item md={2}>
                    <TextField
                        variant="outlined"
                        className={classes.input100}
                        label="Pelaje"
                        type="text"
                        id="pelaje"
                        name="pelaje"
                        value={formik.values.pelaje}
                        onChange={formik.handleChange}
                        helperText="Ej. Blanco"
                    />
                </Grid>
                <Grid item md={2}>
                    <TextField
                        variant="outlined"
                        className={classes.input100}
                        label="Cantidad de Mascotas"
                        type="text"
                        id="cantMascotas"
                        name="cantMascotas"
                        value={formik.values.cantMascotas}
                        onChange={formik.handleChange}
                    />
                </Grid> */}
      </Grid>
    </>
  );
}

export default Step4;
